<div class="systemSettingsContainer">
  <ul class="tab tab-pills">
    <li (click)="setTab('configSettings')"
        (mouseenter)="sysHover = true" (mouseleave)="sysHover = false">
      <a [ngClass]="{'activeTab': tab === 'configSettings', 'inactiveTab': tab !== 'configSettings' && sysHover}">System Settings</a>
    </li>
    <li (click)="setTab('appconfigSettings')"
        (mouseenter)="appHover = true" (mouseleave)="appHover = false">
      <a [ngClass]="{'activeTab': tab === 'appconfigSettings', 'inactiveTab': tab !== 'appconfigSettings' && appHover}">App Settings</a>
    </li>
    <li (click)="setTab('clientconfigSettings')"
        (mouseenter)="clientHover = true" (mouseleave)="clientHover = false">
      <a [ngClass]="{'activeTab': tab === 'clientconfigSettings', 'inactiveTab': tab !== 'clientconfigSettings' && clientHover}">Client Settings</a>
    </li>
  </ul>
  <hr>

  <!-- ===== SYSTEM SETTINGS TAB ===== -->
  @if (tab === 'configSettings') {

    @if (!loading && serverSettings.configSettings.length > 0) {
<div class="searchRow">
      <div class="toolbar-left">
        <span class="btn btn-primary btn-xs resetBtn" (click)="confirmResetServerCache()">Reset Server Settings Cache</span>
        <span class="btn btn-info btn-xs userSwitchBtn" (click)="openSwitchUserModal()">User Switch</span>
        <span class="btn btn-info btn-xs userSwitchBtn" (click)="openCreateSettingsModal()">Create New System Settings</span>
      </div>
      <div class="toolbar-right">
        <div class="searchDiv">
          <div class="searchBlock">
            <input type="text" class="contentSearch" [ngModel]="searchConfig" (ngModelChange)="onSearchChange($event)" placeholder="Settings Search">
          </div>
          <i class="fa fa-search searchIcons"></i>
        </div>
      </div>
    </div>
}
  
}

  <!-- ===== APP SETTINGS TAB ===== -->
  @if (tab === 'appconfigSettings') {

    @if (!loading) {
<div class="searchRow">
      <div class="toolbar-left">
        <span class="btn btn-primary btn-xs resetBtn" (click)="confirmResetServerCache()">Reset Server Settings Cache</span>
        <select class="form-control input-sm inline-select" [(ngModel)]="selectedAppClient" (ngModelChange)="onAppClientChange()">
          @for (client of clients; track $index) {
<option [ngValue]="client">{{ client.client_name }}</option>
}
        </select>
        <select class="form-control input-sm inline-select" [(ngModel)]="selectedChannel">
          @for (channel of channelList; track $index) {
<option [ngValue]="channel">{{ channel.channel_name }}</option>
}
        </select>
        <button class="btn btn-info btn-sm" type="button" (click)="loadAppSettings()">Load</button>
        <span class="btn btn-info btn-xs userSwitchBtn" (click)="openCreateSettingsModal()">Create New App Settings</span>
      </div>
      @if (serverSettings.appconfigSettings.length > 0) {
<div class="toolbar-right">
        <div class="searchDiv">
          <div class="searchBlock">
            <input type="text" class="contentSearch" [ngModel]="searchAppConfig" (ngModelChange)="onSearchChange($event)" placeholder="Settings Search">
          </div>
          <i class="fa fa-search searchIcons"></i>
        </div>
      </div>
}
    </div>
}
  
}

  <!-- ===== CLIENT SETTINGS TAB ===== -->
  @if (tab === 'clientconfigSettings') {

    @if (!loading) {
<div class="searchRow">
      <div class="toolbar-left">
        <span class="btn btn-primary btn-xs resetBtn" (click)="confirmResetServerCache()">Reset Server Settings Cache</span>
        <select class="form-control input-sm inline-select" [(ngModel)]="selectedClient" (ngModelChange)="loadClientSettings()">
          @for (client of clients; track $index) {
<option [ngValue]="client">{{ client.client_name }}</option>
}
        </select>
        <span class="btn btn-info btn-xs userSwitchBtn" (click)="openCreateSettingsModal()">Create New Client Settings</span>
      </div>
      @if (serverSettings.clientconfigSettings.length > 0) {
<div class="toolbar-right">
        <div class="searchDiv">
          <div class="searchBlock">
            <input type="text" class="contentSearch" [ngModel]="searchClientConfig" (ngModelChange)="onSearchChange($event)" placeholder="Settings Search">
          </div>
          <i class="fa fa-search searchIcons"></i>
        </div>
      </div>
}
    </div>
}
  
}

  <!-- Loader -->
  @if (loading) {
<div class="loading-indicator">
    <i class="fa fa-spinner fa-spin" style="color: #e12827; font-size: 24px;"></i>
  </div>
}

  <!-- No settings message -->
  @if (!loading && visibleRows.length < 1) {
<div class="noSettings">
    No settings to display.
  </div>
}

  <!-- Settings 3-column grid -->
  @if (!loading && visibleRows.length > 0) {
<div class="settings-list">
    <div class="settingsBlock customScroll">
      <div class="data-view">
        @for (row of visibleRows; track trackByConfigKey(i, row); let i = $index) {
<div class="col-md-4 setting-card"
            
             [style.margin-top.px]="i > 2 ? 16 : 0"
             (mouseenter)="row.hover = true"
             (mouseleave)="row.hover = false">
          <div class="col-md-12 allSettings"
               [ngClass]="{'selected': row.toggle, 'inactiveTab': !row.toggle && row.hover}">
            <span class="settingLogo" [ngClass]="{'selected': row.toggle}">
              <i class="fa fa-cog"></i>
            </span>
            <span class="settingName" [title]="row.NAME">{{ row.NAME }}</span>
            <span class="settingActions">
              <i class="fa fa-save action-icon"
                 [class.action-icon--hidden]="!(row.toggle && row.enableActions && !!row.VALUE)"
                 (click)="saveRow(row, tab)" title="Save"></i>
              <i class="fa fa-times-circle action-icon"
                 [class.action-icon--hidden]="!(row.toggle && row.enableActions)"
                 (click)="resetRow(row, tab)" title="Reset"></i>
              @if (!row.loadingDeleteSettings) {
<i class="fa fa-trash-o action-icon"
                
                 (click)="deleteRow(row, tab)"
                 title="Delete"></i>
}
              @if (row.loadingDeleteSettings) {
<i class="fa fa-spinner fa-spin action-icon"
                ></i>
}
              <i class="fa action-icon"
                 [ngClass]="row.toggle ? 'fa-minus-square-o' : 'fa-plus-square-o'"
                 (click)="toggleRow(row)"></i>
            </span>
          </div>
          @if (row.toggle) {
<div class="editBlock">
            @if (row.loading) {
<div class="settingsOverlay">
              <div class="settingsSpinner">
                <i class="fa fa-spinner fa-spin"></i>
              </div>
            </div>
}
            <textarea class="form-control customScroll" rows="4"
                      [ngClass]="{'settingValRequired': !row.VALUE}"
                      [(ngModel)]="row.VALUE"
                      (ngModelChange)="onValueChange(row)"></textarea>
          </div>
}
        </div>
}
        @if (visibleRows.length > 0) {
<div class="clearfix"></div>
}
      </div>
    </div>
  </div>
}

  <!-- Confirmation popup for Reset Server Settings Cache -->
  @if (showConfirmReset) {
<div class="confirmation-modal-overlay">
    <gtw-confirmation-modal
      [config]="confirmResetConfig"
      [visible]="false"
      (confirmed)="onConfirmResetYes()"
      (cancelled)="onConfirmResetNo()"
      (closed)="onConfirmResetNo()">
    </gtw-confirmation-modal>
  </div>
}
</div>
